var $7ed9c6fad16a15ec$exports = {};
$7ed9c6fad16a15ec$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Vrednost mora da bude ".concat(args.maxValue, " ili starija.");
  },
  "rangeReversed": "Datum po\u010Detka mora biti pre datuma zavr\u0161etka.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Vrednost mora da bude ".concat(args.minValue, " ili novija.");
  },
  "unavailableDate": "Izabrani datum nije dostupan."
};
export { $7ed9c6fad16a15ec$exports as default };